var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHex1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 25,
    viewBox: "0 0 105 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.09 0.420044H7.03L0 12.6L7.03 24.78H21.09L28.12 12.6L21.09 0.420044Z",
    fill: "#D56B4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.08 0H45.02L37.98 12.18L45.02 24.36H59.08L66.11 12.18L59.08 0Z",
    fill: "#F1805E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.06 0H83L75.97 12.18L83 24.36H97.06L104.09 12.18L97.06 0Z",
    fill: "#F1805E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104.09,
    height: 24.78,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHex1);
export default __webpack_public_path__ + "static/media/hex_1.727cc95334493310f29ac18c0462067d.svg";
export { ForwardRef as ReactComponent };